import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaChevronRight } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const ShopFavorites = () => {
  const [leftItems, setLeftItems] = useState([]);
  const [centerItems, setCenterItems] = useState([]);
  const [rightItem, setRightItem] = useState(null); 
  const [banners, setBanners] = useState([]);
  const [advertisementUser, setAdvertisementUser] = useState([]);
  const [categoryMap, setCategoryMap] = useState({});

  useEffect(() => {
    const fetchAll = async () => {
      try {
        // // Categories
        // const catRes = await axios.get(
        //   "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_main_category"
        // );
        // if (catRes.data.status === "true" || catRes.data.status === true) {
        //   setCategories(catRes.data.row);
        // }

        // // Subcategories
        // const subRes = await axios.get(
        //   "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_main_subcategory"
        // );
        // if (subRes.data.status === "true" || subRes.data.status === true) {
        //   setSubcategories(subRes.data.row);
        // }

        // Products
        const prodRes = await axios.get(
          "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_create_product"
        );

        if (prodRes.data.status === true || prodRes.data.status === "true") {
          const filtered = prodRes.data.data.filter(
            (item) => item.product_status === "Fashion Top Deals" &&
              item.admin_approval === "approval" &&
              item.paid_approval === "yes"
          );
          setLeftItems(filtered);
        } else {
          toast.error("Failed to fetch product list!");
        }

      } catch (error) {
        console.error("Error fetching:", error);
        toast.error("Error fetching product list.");
      }
    };

    fetchAll();
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get(
  //         "https://cyberathon.com/streekatha/API/index.php/Master_controller/shop_categories_list"
  //       );

  //       // Slice the first 4 items only
  //       const limitedData2 = response.data.result.slice(5, 8);
  //       setCenterItems(limitedData2);
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };

  //   fetchData();
  // }, []);


  // useEffect(() => {

  //   // Right Box - only 1 dummy image
  //   fetch("https://fakestoreapi.com/products/1")
  //     .then((res) => res.json())
  //     .then((data) => setRightItem(data))
  //     .catch((err) => console.error("Error fetching right box data:", err));
  // }, []);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        // // Categories
        // const catRes = await axios.get(
        //   "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_main_category"
        // );
        // if (catRes.data.status === "true" || catRes.data.status === true) {
        //   setCategories(catRes.data.row);
        // }

        // // Subcategories
        // const subRes = await axios.get(
        //   "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_main_subcategory"
        // );
        // if (subRes.data.status === "true" || subRes.data.status === true) {
        //   setSubcategories(subRes.data.row);
        // }

        // Products
        const prodRes = await axios.get(
          "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_create_product"
        );

        if (prodRes.data.status === true || prodRes.data.status === "true") {
          const filtered = prodRes.data.data.filter(
            (item) => item.product_status === "Shop Your Favorites" &&
              item.admin_approval === "approval" &&
              item.paid_approval === "yes"
          );
          setCenterItems(filtered);
        } else {
          toast.error("Failed to fetch product list!");
        }

      } catch (error) {
        console.error("Error fetching:", error);
        toast.error("Error fetching product list.");
      }
    };

    fetchAll();
  }, []);

  // Fetch Orange Cards data
  // useEffect(() => {
  //   fetch("https://dummyjson.com/products/category/groceries")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       const formatted = (data.products || []).slice(0, 4).map((item) => ({
  //         title: item.category.replace(/-/g, " "),
  //         heading: item.title.split(" ").slice(0, 2).join(" "),
  //         img: item.thumbnail,
  //       }));
  //       setBanners(formatted);
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching orange deals:", err);
  //       setBanners([]);
  //     });
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // ✅ Correct API endpoint
        const response = await axios.get(
          "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_advertisement"
        );

        if (response.data.status === true) {
          setAdvertisementUser(response.data.data);
        } else {
          toast.error("Failed to fetch advertisements");
        }
      } catch (error) {
        console.error(error);
        toast.error("API Error");
      }
    };

    fetchData();
  }, []);



  useEffect(() => {
    const fetchAll = async () => {
      try {
        const prodRes = await axios.get(
          "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_create_product"
        );

        if (prodRes.data.status === true || prodRes.data.status === "true") {
          const filtered = prodRes.data.data.filter(
            (item) => item.product_status === "Groceries" &&
              item.admin_approval === "approval" &&
              item.paid_approval === "yes"
          );
          setBanners(filtered);
        } else {
          toast.error("Failed to fetch product list!");
        }

      } catch (error) {
        console.error("Error fetching:", error);
        toast.error("Error fetching product list.");
      }
    };
    fetchAll();
  }, []);


  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      console.log("=== FETCHING CATEGORIES ===");

      const response = await fetch(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_main_category"
      );

      const result = await response.json();
      console.log("📂 Categories API Response:", result);

      if (result.status === true || result.status === "true") {
        const map = {};
        result.row.forEach((category) => {
          map[category.category_id] = category.category_name;
        });
        setCategoryMap(map);
        console.log("Category Map Created:", map);
      }
    } catch (err) {
      console.error("❌ Category fetch error:", err);
    }
  };
  return (
    <div className="container my-4 ">
      <div className="row">
        {/* Left Box */}
        <div className="col-md-4 prod-left">
          <div className="card p-3" style={{ backgroundColor: "#fff" }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="fw-bold mb-0">Fashions Top Deals</h5>
              <Link
                to="/products"
                state={{ categoryId: 1 }} // 🔥 Electronics ID
                className="text-decoration-none"
                style={{ color: "#ff7043" }}
              >
                <button
  style={{
    background: "var(--primary-gradient)", // ✅ correct
    border: "none",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  }}
>
  <FaChevronRight size={15} color="white" />
</button>
              </Link>
            </div>

            <div className="row g-3">
              {leftItems.map((item, index) => (
                <div className="col-6" key={index}>
                  <Link to={`/model/${item.product_id}`} style={{ textDecoration: 'none' }} key={index}>
                    <div>
                      <div className="shopfav">
                        <img
                          src={`https://cyberathon.com/multivendor/${item.multi_image?.[0]}`}
                          alt={item.product_name}
                          className="img-fluid rounded Product-sec"
                        />
                      </div>
                      <p className="mt-2 mb-0 small text-muted">
                        {item.product_name.length > 35
                          ? item.product_name.substring(0, 35) + "..."
                          : item.product_name}
                      </p>
                    </div>
                  </Link>
                </div>
              ))}
            </div>

            {/* <a href="#" className="text-primary small mt-2 d-inline-block">
      Explore all
    </a> */}
          </div>
        </div>


        {/* Center Box */}
        <div className="col-md-4 center-sec">
          <div className="card p-3" style={{ backgroundColor: "#fff" }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="fw-bold mb-0">Shop Your Favorites</h5>
              <Link
                to="/products"
                state={{ categoryId: 2 }} // 🔥 Electronics ID
                className="text-decoration-none"
                style={{ color: "#ff7043" }}
              >
                <button
  style={{
    background: "var(--primary-gradient)", // ✅ correct
    border: "none",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  }}
>
  <FaChevronRight size={15} color="white" />
</button>
              </Link>
            </div>

            <div className="row g-3">
              {centerItems.map((item, index) => (
                <div className="col-6" key={index}>
                  <Link to={`/model/${item.product_id}`} style={{ textDecoration: 'none' }} key={index}>
                    <div>
                      <div className="shopfav">
                        <img
                          src={`https://cyberathon.com/multivendor/${item.multi_image?.[0]}`}
                          alt={item.product_name}
                          className="img-fluid rounded Product-sec"
                        />
                      </div>
                      <p className="mt-2 mb-0 small text-muted">
                        {item.product_name.length > 35
                          ? item.product_name.substring(0, 35) + "..."
                          : item.product_name}
                      </p>
                    </div>
                  </Link>
                </div>
              ))}
            </div>

            {/* <a href="#" className="text-primary small mt-2 d-inline-block">
      Explore all
    </a> */}
          </div>
        </div>

        {/* Right Box (only one image) */}
        <div className="col-md-4">
          <div className="card p-3" style={{ backgroundColor: "#fff" }}>
            <div className="text-center">
              {advertisementUser
                .filter((item) => item.id === "2")   // 🔥 filter by ID
                .map((item, index) => (
                  <img
                    key={index}
                    src={`https://cyberathon.com/multivendor/${item.image}`}
                    alt={item.title}
                    className="img-fluid rounded Product-secimg"
                  />
                ))}
            </div>

            {/* <a href="#" className="text-primary small mt-2 d-inline-block">
      Explore all
    </a> */}
          </div>
        </div>


        {/* Banners Section */}
        <div className="banner-sec1 d-flex flex-wrap justify-content-between gap-3">
          {banners.length > 0 ? (
            banners.map((banner, index) => (
              <div
                key={index}
                className={`orange-card text-white p-2 ${banner.color}`}
                style={{ flex: "1", minWidth: "300px", borderRadius: "4px" }}
              >
                <div className="card-body d-flex justify-content-between align-items-center">
                  <div>
                    <p className="mb-1 small">{categoryMap[banner.category_id] || "Category"}</p>
                    <h4 className="fw-bold text-white">{banner.product_name}</h4>
                    <Link to={`/model/${banner.product_id}`} style={{ textDecoration: 'none' }}>
                      <button className="btn btn-light fw-semibold mt-2">
                        Shop Now
                      </button>
                    </Link>
                  </div>
                  <img
                    src={`https://cyberathon.com/multivendor/${banner.multi_image?.[0]}`}
                    className="card-img-top bg-white"
                    alt={banner.product_name}
                    style={{ height: "100px", width: "100px", objectFit: "contain" }}
                    onError={(e) => (e.target.src = "/img/placeholder.png")}
                  />
                </div>
              </div>
            ))
          ) : (
            <p>Loading banners...</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShopFavorites;
